// extracted by mini-css-extract-plugin
export default {"form":"Payment_form__cXnjr","column":"Payment_column__iV7Nf","lines":"Payment_lines__jPBXW","line":"Payment_line__cCKG5"};